import React, { useEffect, useState } from 'react';
import {
  Card, CardContent, Typography, Grid, IconButton, Tooltip, Box, CardActionArea
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

function formatTiempoRestante(segundosRestantes) {
  const abs = Math.abs(segundosRestantes);
  const m = Math.floor(abs / 60);
  const s = abs % 60;
  return `${m}m ${s.toString().padStart(2, '0')}s`;
}

export function Signs({ signs, onLogin, onAutocomplete, onRemove }) {
  const [ahora, setAhora] = useState(Date.now() / 1000);

  useEffect(() => {
    const interval = setInterval(() => {
      setAhora(Date.now() / 1000);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const estaExpirado = (sign) => sign.exp < ahora;

  return (
    <Grid container spacing={1}>
      {signs.map((sign) => {
        const segundosRestantes = Math.floor(sign.exp - ahora);
        const expirada = estaExpirado(sign);

        const handleClick = () => {
          if (expirada) {
            onAutocomplete(sign);
          } else {
            onLogin(sign);
          }
        };

        return (
          <Grid item xs={12} sm={6} md={4} key={sign.id}>
            <Card variant="outlined">
              <CardActionArea onClick={handleClick}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="start">

                    <Box>
                      

                        <Typography
                          color={expirada ? 'warning.main' : 'text.primary'}
                          display="flex"
                          alignItems="center"
                        >
                          <Tooltip title={expirada
                            ? `Expirado hace ${formatTiempoRestante(segundosRestantes)}`
                            : `Expira en ${formatTiempoRestante(segundosRestantes)}`}
                          >
                            {expirada && <WarningAmberIcon fontSize="small" sx={{ mr: 0.5 }} />}
                            {sign.nombre}
                          </Tooltip>
                          <Tooltip title="Eliminar del dispositivo">
                            <IconButton
                              color="error"
                              onClick={(e) => {
                                e.stopPropagation(); // evita que se dispare el login
                                onRemove(sign);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Typography>

                        <Typography variant="caption" color="text.secondary">{sign.rol}</Typography>


                    </Box>


                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}
